export default "__VITE_ASSET__H3tn3Re0__"